import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import _, { uniqueId } from 'lodash';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBearingInformationByNumber, saveBearingInformation } from "../../../api";
import ToolTip from '../Common/Tooltip';
import { bearingTypes } from '../Common/sensorData';
import { useMutation, useQuery } from 'react-query';
import { checkForAPISuccess, showErrorToast, showInfoToast, showSuccessToast } from '../../../Common/commonFunctions';
import { useLocation } from 'react-router-dom';
import { ADD_NEW_BEARING } from '../../../store/actions';
import { UNKNOWN_BEARING_IDENTIFIER, useQueryConfiguration } from '../../../Common/constants';
import { ClipLoader } from 'react-spinners';

const BearingRow = ({ displayLabel, component }) =>
    <Col xl={6} lg={6} md={12} sm={12} xs={12} className="my-3 px-3">
        <Row>
            <Col xl={5} lg={4} md={5} sm={5} xs={12} className="text-left">
                <h6 className="mb-0">{displayLabel}</h6>
            </Col>
            <Col xl={7} lg={8} md={7} sm={7} xs={12}>
                {component}
            </Col>
        </Row>
    </Col>

const BearingForm = (props) => {

    const dispatch = useDispatch();

    const selectedComponent = useSelector(state => state.equipment.selectedComponent);

    const location = useLocation();
    const pathname = location.pathname;
    const profileId = pathname.split('/').pop(); 
    const componentId = selectedComponent?.id;

    const [utils, setUtils] = useState({
        bearingType: "", bearingNumber: "", ballDiameter: "",
        ballPassFrequencyInner: "", ballPassFrequencyOuter: "",
        ballSpinFrequency: "", fundamentalTrainFrequency: "",
        numBalls: 8, phi: "", pitchDiameter: "",
        location: "", loading : false,
        drive: "", rotatingInnerRace: ""
    });

    const clearBearingFields = (value) =>
        setUtils({
            ...utils, bearingType: !_.isEmpty(value) ? value : utils.bearingType,
            bearingNumber: "",
            ballDiameter: "", ballPassFrequencyOuter: "", ballPassFrequencyInner: "",
            ballSpinFrequency: "", fundamentalTrainFrequency: "", numBalls: 8,
            phi: "", pitchDiameter: "", rotatingInnerRace: ""
        });

    const fetchBearingData = async () => {
       const response = await fetchBearingInformationByNumber(profileId, utils.bearingNumber);
       return response.data;
    }

    const returnBearingNumber = () => {
        if(_.isEqual(utils.bearingType, bearingTypes[1])) {
            return "";
        }
        return _.isEmpty(utils.bearingNumber) ? UNKNOWN_BEARING_IDENTIFIER : utils.bearingNumber;
    }

    const saveBearing = async () => {

        const bearingInformation = {
            profileId : profileId,
            componentId : componentId,
            location : utils.location,
            bearingNumber : returnBearingNumber(),
            numBalls: utils.numBalls || 8,
            ballDiameter: utils.ballDiameter,
            pitchDiameter: utils.pitchDiameter,
            phi: utils.phi,
            ballPassFrequencyOuter: utils.ballPassFrequencyOuter,
            ballPassFrequencyInner: utils.ballPassFrequencyInner,
            fundamentalTrainFrequency: utils.fundamentalTrainFrequency,
            ballSpinFrequency: utils.ballSpinFrequency,
            rotatingInnerRace: utils.rotatingInnerRace,
            drive: utils.drive
        }
        
        const response = await saveBearingInformation(bearingInformation)
        return response.data;
    }

    const fetchBearingDataQuery = useQuery("fetch-bearing-information", fetchBearingData, { ...useQueryConfiguration });
    const saveBearingInformationQuery = useMutation(saveBearing);


    useEffect(() => {
        if(fetchBearingDataQuery.isFetched) {
            if (
                fetchBearingDataQuery.isSuccess &&
                checkForAPISuccess(fetchBearingDataQuery?.data?.statusCode)
            ) {
                const responseBearingData = fetchBearingDataQuery?.data;
                if(!_.isEmpty(responseBearingData?.data)) {
                    setUtils({
                        ...utils,
                        ballDiameter: responseBearingData?.data?.ballDiameter,
                        ballPassFrequencyInner: responseBearingData?.data?.ballPassFrequencyInner,
                        ballPassFrequencyOuter: responseBearingData?.data?.ballPassFrequencyOuter,
                        ballSpinFrequency: responseBearingData?.data?.ballSpinFrequency,
                        fundamentalTrainFrequency: responseBearingData.data?.fundamentalTrainFrequency,
                        numBalls: responseBearingData?.data?.numBalls,
                        phi: responseBearingData?.data?.phi,
                        pitchDiameter: responseBearingData?.data?.pitchDiameter,
                        rotatingInnerRace: responseBearingData?.data?.rotatingInnerRace
                    });
                }
                else {
                    showInfoToast("Provided bearing not found. Enter its values", 5000);
                }
            }
            else if (fetchBearingDataQuery.isError) {
                showErrorToast("Bearing fetch failed");
            }
            fetchBearingDataQuery.remove();
        }
    }, [fetchBearingDataQuery.isFetched, fetchBearingDataQuery.data]);    

    useEffect( () => {
        if(saveBearingInformationQuery.isSuccess || saveBearingInformationQuery.isError) {
            if(
                saveBearingInformationQuery.isSuccess &&
                checkForAPISuccess(saveBearingInformationQuery?.data?.statusCode)
            ) {
                let bearingInformation;
                if(_.isEqual(utils.bearingType, bearingTypes[1])) {
                    bearingInformation = {
                       bearingType : utils.bearingType,
                       location: utils.location,
                       drive: utils.drive
                    }
                }
                else {
                    bearingInformation = {
                        bearingNumber : returnBearingNumber(),
                        ballDiameter: utils.ballDiameter,
                        ballPassFrequencyInner: utils.ballPassFrequencyInner,
                        ballPassFrequencyOuter: utils.ballPassFrequencyOuter,
                        ballSpinFrequency: utils.ballSpinFrequency,
                        fundamentalTrainFrequency: utils.fundamentalTrainFrequency,
                        numBalls: utils.numBalls,
                        phi: utils.phi,
                        pitchDiameter: utils.pitchDiameter,
                        rotatingInnerRace: utils.rotatingInnerRace,
                        location: utils.location,
                        drive: utils.drive
                    }
                }
                showSuccessToast("Bearing information saved successfully");
                dispatch({
                    type: ADD_NEW_BEARING,
                    payload: bearingInformation
                });
            }
            else {
                showErrorToast("Failed to update bearing");
            }
        }
    },[saveBearingInformationQuery.isSuccess, saveBearingInformationQuery.isError])

    const handleBearingNumberChange = (e) => {
        const { value } = e.target;
        setUtils({
            ...utils,
            bearingNumber: value,
            ballDiameter: "",
            ballPassFrequencyInner: "",
            rotatingInnerRace: "",
            ballPassFrequencyOuter: "",
            ballSpinFrequency: "",
            fundamentalTrainFrequency: "",
            numBalls: "",
            phi: "",
            pitchDiameter: ""
        });
    };

    const returnAddButtonCondition = () => !bearingTypes.includes(utils.bearingType) || _.isEmpty(utils.location) || _.isEmpty(utils.drive);

    const getBearingNumberField = () =>
        <BearingRow
            displayLabel={"bearing_number"}
            component={
                <>
                    <div className='vertical-center-align'>
                        <input
                            className="mb-0 bearing-form text-center flex-grow-1"
                            type='text'
                            onChange={handleBearingNumberChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    fetchBearingDataQuery.refetch()
                                }
                            }}
                            value={utils.bearingNumber}
                        />
                        <ToolTip
                            toolTipKey='Fetch'
                            toolTipValue="Auto fill"
                            overlayComponent={
                                <span
                                    className={`display-${utils.bearingNumber !== "0" ? "block" : "none"}`}
                                >
                                    <Icon
                                        className='pointer bearing-form-search'
                                        onClick={() => fetchBearingDataQuery.refetch()}
                                        icon="feather:search"
                                    />
                                </span>
                            }
                        />
                    </div>
                    <span
                        className={`bearing-field-validation display-${utils.bearingNumber === "0" ? "block" : "none"}`}
                    >
                        PROVIDE VALID BEARING NUMBER
                    </span>
                </>
            }
        />
    
    const getBearingTypeDropdown = () =>
        <BearingRow
            displayLabel={"Bearing Type"}
            component={
                <select
                    value={utils.bearingType || "1"}
                    onChange={(e) => clearBearingFields(e.target.value)}
                    className="mb-0 default-bearing-fields"
                >
                    <option disabled value={"1"}>Select the Bearing type</option>
                    {
                        bearingTypes.map(type =>
                            <option key={uniqueId()} value={type}>{type}</option>
                        )
                    }
                </select>
            }
        />

    const getLocationDropdown = () =>
        <BearingRow
            displayLabel={"bearing_location"}
            component={
                <select
                    value={utils.location || "1"}
                    onChange={(e) => setUtils({...utils, location: e.target.value})}
                    className="mb-0 default-bearing-fields"
                >
                    <option disabled value={"1"}>Select the Location</option>
                    {
                        props.availableLocations?.map(type => 
                            <option key={uniqueId()} value={type}>{type}</option>
                        )
                    }
                </select>
            }
        />

    const getRotatingInnerRaceDropdown = () =>
        <BearingRow
            displayLabel={"rotating_inner_race"}
            component={
                <select
                    value={_.isBoolean(utils.rotatingInnerRace) ? utils.rotatingInnerRace : "1"}
                    onChange={(e) => setUtils({...utils, rotatingInnerRace: e.target.value === "true"})}
                    className="mb-0 default-bearing-fields"
                >
                    <option disabled value={"1"}>Select the Location</option>
                    <option key={uniqueId()}>true</option>
                    <option key={uniqueId()}>false</option>
                </select>
            }
        />

    const getDriveField = () => 
        <BearingRow
            displayLabel={"drive"}
            component={
                <>
                    <input
                        maxLength={1}
                        className="mb-0 bearing-form text-center w-100"
                        value={utils.drive}
                        onChange={(event) => setUtils({ ...utils, drive: event.target.value })}
                    />
                    {
                        !_.isEmpty(utils.drive) && !(/^[a-z]$/.test(utils.drive)) &&
                            <span>Provide value between a to z</span>
                    }
                </>
            }
        />

    const getBearingField = (displayLabel, name, value) =>
        <BearingRow
            displayLabel={displayLabel}
            component={
                <input
                    className="mb-0 bearing-form text-center w-100"
                    type={"number"}
                    value={value}
                    onChange={(event) => setUtils({ ...utils, [name]: event.target.value ? parseFloat(event.target.value) : "" })}
                />
            }
        />
    
    return (
        <>
            <Row className='m-1'>
                {getBearingTypeDropdown()}
                {getLocationDropdown()}
            </Row>
            {
                utils.bearingType === bearingTypes[0] && (
                    <>
                        <Row className='m-1'>
                            {getBearingNumberField()}
                            {getBearingField("num_balls", "numBalls", utils.numBalls || 8)}
                        </Row>
                        <Row className='m-1'>
                            {getBearingField("pitch_diameter", "pitchDiameter", utils.pitchDiameter)}
                            {getBearingField("ball_diameter", "ballDiameter", utils.ballDiameter)}
                        </Row>
                        <Row className='m-1'>
                            {getBearingField("bpfo", "ballPassFrequencyOuter", utils.ballPassFrequencyOuter)}
                            {getBearingField("contact_angle", "phi", utils.phi)}
                        </Row>
                        <Row className='m-1'>
                            {getBearingField("ftf", "fundamentalTrainFrequency", utils.fundamentalTrainFrequency)}
                            {getBearingField("bpfi", "ballPassFrequencyInner", utils.ballPassFrequencyInner)}
                        </Row>
                        <Row className='m-1'>
                            {getBearingField("bsf", "ballSpinFrequency", utils.ballSpinFrequency)}
                            {getRotatingInnerRaceDropdown()}
                        </Row>
                    </>
                )
            }
            <Row className='m-1'>
                {getDriveField()}
            </Row>
            <div className='d-flex justify-content-end mb-2'>
                <Button
                    disabled={returnAddButtonCondition() || utils.loading}
                    className="btn btn-lg" 
                    onClick={() => saveBearingInformationQuery.mutate()}
                >
                    {
                        saveBearingInformationQuery.isLoading ?
                            <ClipLoader color='#BABABA' />
                                :
                            "Add"
                    }
                </Button>
            </div>
        </>
    );
    
}

export default BearingForm